import Box from '@mui/material/Box';
import React, { PropsWithChildren } from 'react';

interface Props {
  sx?: any;
}

const WsFormBox = (props: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        '& .MuiTextField-root': { mb: 1 },
        ...props.sx,
      }}
    >
      {props.children}
    </Box>
  );
};

export default WsFormBox;
